// Wycena dostawy w koszyku – opis w snippets/wycena-koszyk.liquid.
// Przycisk kasy (name="checkout") w szufladzie i na stronie koszyka: w kraju z wyceną i z meblami w koszyku
// zmienia napis na „Wyślij do wyceny” i zamiast kasy otwiera formularz zapytania. Do tego (właściciel 30.10:
// „mało czytelne”): pasek „darmowa dostawa” → „dostawa: wycena indywidualna”, nad przyciskiem jedna linia
// „Dostawa do [flaga] HOLANDIA (EUR) · Zmień” (jak w szufladzie wyboru rynku – „Zmień” ją otwiera; klient mógł
// wcześniej wybrać zły kraj, np. Holandię zamiast Niemiec) i „Dostawa – Wycena indywidualna”.
// Od progu darmowej dostawy (ustawienia aplikacji `freeAbove`, Holandia 2000 € – właściciel 30.10) zwykła kasa
// i „Dostawa – Gratis”; poniżej wycena z dopiskiem „darmowa od 2000 €”.
(function () {
  var W = window.WYCENA;
  if (!W || !window.fetch) return;

  var TEXTS = {
    pl: {
      button: 'Wyślij do wyceny',
      banner: 'Dostawa – {country}: wycena indywidualna',
      deliveryTo: 'Dostawa do', delivery: 'Dostawa', change: 'Zmień', quote: 'Wycena indywidualna',
      free: 'Gratis', bannerFree: 'Darmowa dostawa – {country}', freeFrom: 'Darmowa dostawa od {min}',
      title: 'Wycena dostawy',
      intro: 'Dostawę do Twojego kraju wyceniamy indywidualnie. Jesteśmy producentem i sami organizujemy transport, żeby był jak najkorzystniejszy cenowo. W ciągu {hours} h wyślemy Ci e-mailem cenę dostawy i link do zamówienia.',
      email: 'E-mail', firstName: 'Imię', lastName: 'Nazwisko', phone: 'Telefon (opcjonalnie)', address1: 'Ulica i numer',
      address2: 'Mieszkanie, piętro (opcjonalnie)', zip: 'Kod pocztowy', city: 'Miasto', country: 'Kraj',
      note: 'Uwagi (opcjonalnie) – np. piętro, winda, preferowany termin',
      consent: 'Wysyłając zapytanie, zgadzasz się na kontakt w sprawie wyceny dostawy.', privacy: 'Polityka prywatności',
      submit: 'Wyślij zapytanie', sending: 'Wysyłamy…',
      sentTitle: 'Zapytanie wysłane',
      sent: 'Dziękujemy! W ciągu {hours} h wyślemy wycenę dostawy na adres {email}. Potwierdzenie jest już w Twojej skrzynce.',
      close: 'Zamknij', missing: 'Uzupełnij zaznaczone pola.',
      limit: 'Dostaliśmy już dziś kilka zapytań z tego adresu. Odezwiemy się wkrótce – albo napisz do nas: sklep@optisofa.com.',
      error: 'Nie udało się wysłać zapytania. Spróbuj ponownie albo napisz do nas: sklep@optisofa.com.'
    },
    de: {
      button: 'Zur Angebotsanfrage senden',
      banner: 'Lieferung nach {country}: individuelles Angebot',
      deliveryTo: 'Lieferung nach', delivery: 'Lieferung', change: 'Ändern', quote: 'Individuelles Angebot',
      free: 'Kostenlos', bannerFree: 'Kostenlose Lieferung nach {country}', freeFrom: 'Kostenlose Lieferung ab {min}',
      title: 'Lieferangebot',
      intro: 'Die Lieferung in Ihr Land kalkulieren wir individuell. Als Hersteller organisieren wir den Transport selbst, damit er so günstig wie möglich ist. Innerhalb von {hours} Stunden senden wir Ihnen den Lieferpreis und einen Link zur Bestellung per E-Mail.',
      email: 'E-Mail', firstName: 'Vorname', lastName: 'Nachname', phone: 'Telefon (optional)', address1: 'Straße und Hausnummer',
      address2: 'Wohnung, Etage (optional)', zip: 'PLZ', city: 'Stadt', country: 'Land',
      note: 'Hinweise (optional) – z. B. Etage, Aufzug, Wunschtermin',
      consent: 'Mit dem Absenden stimmen Sie der Kontaktaufnahme zum Lieferangebot zu.', privacy: 'Datenschutzerklärung',
      submit: 'Anfrage senden', sending: 'Wird gesendet…',
      sentTitle: 'Anfrage gesendet',
      sent: 'Vielen Dank! Innerhalb von {hours} Stunden senden wir das Lieferangebot an {email}. Die Bestätigung ist bereits in Ihrem Postfach.',
      close: 'Schließen', missing: 'Bitte füllen Sie die markierten Felder aus.',
      limit: 'Wir haben heute bereits mehrere Anfragen von dieser Adresse erhalten. Wir melden uns in Kürze – oder schreiben Sie uns: shop@optisofa.com.',
      error: 'Die Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es erneut oder schreiben Sie uns: shop@optisofa.com.'
    },
    en: {
      button: 'Send for a quote',
      banner: 'Delivery to {country}: individual quote',
      deliveryTo: 'Delivery to', delivery: 'Delivery', change: 'Change', quote: 'Individual quote',
      free: 'Free', bannerFree: 'Free delivery to {country}', freeFrom: 'Free delivery from {min}',
      title: 'Delivery quote',
      intro: 'Delivery to your country is quoted individually. As the manufacturer we arrange transport ourselves to keep it as affordable as possible. Within {hours} hours we will email you the delivery price and a link to complete your order.',
      email: 'Email', firstName: 'First name', lastName: 'Last name', phone: 'Phone (optional)', address1: 'Street and number',
      address2: 'Apartment, floor (optional)', zip: 'Postal code', city: 'City', country: 'Country',
      note: 'Notes (optional) – e.g. floor, lift, preferred date',
      consent: 'By sending the request you agree to be contacted about the delivery quote.', privacy: 'Privacy policy',
      submit: 'Send request', sending: 'Sending…',
      sentTitle: 'Request sent',
      sent: 'Thank you! Within {hours} hours we will send the delivery quote to {email}. A confirmation is already in your inbox.',
      close: 'Close', missing: 'Please fill in the highlighted fields.',
      limit: 'We have already received several requests from this address today. We will get back to you shortly – or write to us at shop@optisofa.com.',
      error: "We couldn't send the request. Please try again or write to us at shop@optisofa.com."
    }
  };
  var lang = String(W.locale || '').slice(0, 2);
  var T = TEXTS[lang] || TEXTS.en;
  var settings = null;
  var cart = null;
  var pass = false;

  function fmt(s, vars) {
    return s.replace(/\{(\w+)\}/g, function (_, k) { return vars[k] != null ? vars[k] : ''; });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  // Ta sama zasada co w kasie (blokada-kraju) i na serwerze (appliesTo).
  function inScope() {
    if (!settings || !settings.enabled || !W.country) return false;
    return settings.mode === 'except'
      ? (settings.excludedCountries || []).indexOf(W.country) < 0
      : (settings.countries || []).indexOf(W.country) >= 0;
  }
  // Meble w koszyku (nie same próbki) – dotyczy nas: wycena albo darmowa dostawa od progu.
  function hasFurniture(c) {
    var skip = settings.skipProductTypes || [];
    return !!c && c.items.length > 0 && !c.items.every(function (i) { return skip.indexOf(i.product_type) >= 0; });
  }
  // Ta sama zasada co blokada-kraju: wartość produktów w walucie progu ≥ progu.
  function isFree(c) {
    var f = settings.freeAbove;
    return !!(f && c && c.currency === f.currencyCode && c.items_subtotal_price / 100 >= Number(f.amount));
  }
  function needsQuote(c) {
    return hasFurniture(c) && !isFree(c);
  }
  function freeMin() {
    var f = settings.freeAbove;
    if (!f) return '';
    try {
      return new Intl.NumberFormat(W.locale || 'en', { style: 'currency', currency: f.currencyCode, maximumFractionDigits: 0 }).format(f.amount);
    } catch (e) {
      return f.amount + ' ' + f.currencyCode;
    }
  }

  function loadSettings() {
    try {
      var cached = JSON.parse(sessionStorage.getItem('wycena-ustawienia') || 'null');
      if (cached && Date.now() - cached.at < 5 * 60 * 1000) return Promise.resolve(cached.value);
    } catch (e) {}
    return fetch(W.api + '/api/ustawienia').then(function (r) { return r.ok ? r.json() : null; }).then(function (value) {
      try { sessionStorage.setItem('wycena-ustawienia', JSON.stringify({ at: Date.now(), value: value })); } catch (e) {}
      return value;
    });
  }
  function loadCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { cart = c; return c; });
  }

  function label() {
    var on = needsQuote(cart);
    var buttons = document.querySelectorAll('button[name="checkout"]');
    for (var i = 0; i < buttons.length; i++) {
      var b = buttons[i];
      b.setAttribute('data-wycena-seen', '');
      if (on) {
        if (!b.hasAttribute('data-wycena-orig')) b.setAttribute('data-wycena-orig', b.textContent);
        b.textContent = T.button;
      } else if (b.hasAttribute('data-wycena-orig')) {
        b.textContent = b.getAttribute('data-wycena-orig');
        b.removeAttribute('data-wycena-orig');
      }
    }
  }

  // Pasek „darmowa dostawa” i linia „Dostawa do <kraj> · Zmień – Wycena indywidualna” nad przyciskiem
  // – z zapamiętaniem oryginału, żeby wrócić, gdy w koszyku zostaną same próbki.
  function swapText(selector, text, on) {
    var els = document.querySelectorAll(selector);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (on) {
        if (!el.hasAttribute('data-wycena-orig')) el.setAttribute('data-wycena-orig', el.textContent);
        el.textContent = text;
      } else if (el.hasAttribute('data-wycena-orig')) {
        el.textContent = el.getAttribute('data-wycena-orig');
        el.removeAttribute('data-wycena-orig');
      }
    }
  }
  // „Zmień” otwiera szufladę wyboru rynku motywu (snippets/market-switcher.liquid, przycisk w górnym pasku).
  function deliveryRow(free) {
    var row = document.createElement('div');
    row.className = 'wycena-delivery';
    row.setAttribute('data-free', free ? '1' : '0');
    var min = freeMin();
    var canChange = !!document.querySelector('[market-switcher-trigger]');
    row.innerHTML =
      '<div class="wycena-delivery__row t-small">' +
        '<span class="wycena-delivery__to">' + esc(T.deliveryTo) +
          (W.flag ? ' <img src="' + esc(W.flag) + '" alt="" width="20" height="20">' : ' ') +
          '<span>' + esc(W.countryName) + (W.currency ? ' (' + esc(W.currency) + ')' : '') + '</span></span>' +
        (canChange ? '<button type="button" class="wycena-delivery__change">' + esc(T.change) + '</button>' : '') +
      '</div>' +
      '<div class="wycena-delivery__row t-small"><span>' + esc(T.delivery) + '</span><span class="t-bold">' + esc(free ? T.free : T.quote) + '</span></div>' +
      (!free && min ? '<div class="wycena-delivery__hint t-small">' + esc(fmt(T.freeFrom, { min: min })) + '</div>' : '');
    var change = row.querySelector('.wycena-delivery__change');
    if (change) {
      change.addEventListener('click', function () {
        var trigger = document.querySelector('[market-switcher-trigger]');
        if (trigger) trigger.click();
      });
    }
    return row;
  }
  function decorate() {
    var on = hasFurniture(cart);
    var free = isFree(cart);
    var banner = free ? fmt(T.bannerFree, { country: W.countryName }) : fmt(T.banner, { country: W.countryName });
    // Wartość koszyka się zmienia bez przerysowania paska – tekst ustawiany za każdym razem (oryginał zapamiętany raz).
    swapText('.cart-drawer__free-delivery span, .cart-main__free-delivery span', banner, false);
    if (on) swapText('.cart-drawer__free-delivery span, .cart-main__free-delivery span', banner, true);
    var forms = document.querySelectorAll('.cart-drawer__summary-checkout-form, .cart-main__summary-checkout-form');
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i];
      var row = f.previousElementSibling && f.previousElementSibling.classList.contains('wycena-delivery') ? f.previousElementSibling : null;
      if (row && (!on || row.getAttribute('data-free') !== (free ? '1' : '0'))) { row.remove(); row = null; }
      if (on && !row) f.parentNode.insertBefore(deliveryRow(free), f);
    }
  }

  var refreshTimer = null;
  function refreshSoon() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () { loadCart().then(function () { label(); decorate(); }).catch(function () {}); }, 150);
  }

  function field(name, opts) {
    opts = opts || {};
    var v = (W.customer && W.customer[name]) || '';
    var tag = opts.textarea
      ? '<textarea name="' + name + '" id="wycena-' + name + '"></textarea>'
      : '<input name="' + name + '" id="wycena-' + name + '" type="' + (opts.type || 'text') + '" autocomplete="' + (opts.ac || 'on') + '" value="' + esc(v) + '"' + (opts.required ? ' required' : '') + '>';
    return '<div class="' + (opts.wide ? 'wide' : '') + '"><label for="wycena-' + name + '">' + esc(T[name]) + '</label>' + tag + '</div>';
  }

  function openDialog() {
    var d = document.createElement('dialog');
    d.className = 'wycena-dialog';
    var hours = settings.hours || 12;
    var privacy = W.privacyUrl ? ' <a href="' + esc(W.privacyUrl) + '" target="_blank" rel="noopener">' + esc(T.privacy) + '</a>' : '';
    d.innerHTML =
      '<div class="wycena-dialog__inner">' +
        '<div class="wycena-dialog__head"><h2 class="h4 uppercase">' + esc(T.title) + '</h2>' +
        '<button type="button" class="wycena-dialog__close" aria-label="' + esc(T.close) + '">✕</button></div>' +
        '<div data-body>' +
          '<p class="wycena-dialog__intro t-small">' + esc(fmt(T.intro, { hours: hours })) + '</p>' +
          '<form novalidate>' +
            '<div class="wycena-dialog__grid">' +
              field('email', { type: 'email', ac: 'email', required: true, wide: true }) +
              field('firstName', { ac: 'given-name', required: true }) +
              field('lastName', { ac: 'family-name', required: true }) +
              field('address1', { ac: 'address-line1', required: true, wide: true }) +
              field('address2', { ac: 'address-line2', wide: true }) +
              field('zip', { ac: 'postal-code', required: true }) +
              field('city', { ac: 'address-level2', required: true }) +
              '<div><label>' + esc(T.country) + '</label><div class="wycena-dialog__country">' + esc(W.countryName) + '</div></div>' +
              field('phone', { type: 'tel', ac: 'tel' }) +
              field('note', { textarea: true, wide: true }) +
            '</div>' +
            '<div class="wycena-dialog__hp" aria-hidden="true"><input name="website" tabindex="-1" autocomplete="off"></div>' +
            '<p class="wycena-dialog__consent">' + esc(T.consent) + privacy + '</p>' +
            '<button type="submit" class="btn btn--primary btn--full">' + esc(T.submit) + '</button>' +
            '<div data-msg></div>' +
          '</form>' +
        '</div>' +
      '</div>';
    document.body.appendChild(d);
    var close = function () { d.close(); };
    d.querySelector('.wycena-dialog__close').addEventListener('click', close);
    d.addEventListener('close', function () { d.remove(); });
    d.addEventListener('click', function (e) { if (e.target === d) close(); });

    var form = d.querySelector('form');
    var msg = d.querySelector('[data-msg]');
    var btn = form.querySelector('button[type="submit"]');
    function show(text, error) {
      msg.innerHTML = '<p class="wycena-dialog__msg' + (error ? ' wycena-dialog__msg--error' : '') + ' t-small">' + esc(text) + '</p>';
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var data = {};
      new FormData(form).forEach(function (v, k) { data[k] = String(v).trim(); });
      var missing = [];
      ['email', 'firstName', 'lastName', 'address1', 'zip', 'city'].forEach(function (k) {
        var el = form.elements[k];
        var bad = !data[k] || (k === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(data[k]));
        el.classList.toggle('is-missing', bad);
        if (bad) missing.push(k);
      });
      if (missing.length) { show(T.missing, true); form.elements[missing[0]].focus(); return; }

      btn.disabled = true;
      btn.textContent = T.sending;
      msg.innerHTML = '';
      loadCart().then(function (c) {
        return fetch(W.api + '/api/zapytanie-sklep', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: data.email,
            phone: data.phone,
            language: W.locale,
            note: data.note,
            website: data.website,
            address: {
              firstName: data.firstName, lastName: data.lastName, address1: data.address1, address2: data.address2,
              zip: data.zip, city: data.city, countryCode: W.country
            },
            lines: c.items.map(function (i) {
              return { variantId: i.variant_id, quantity: i.quantity, title: i.product_title + (i.variant_title ? ' – ' + i.variant_title : '') };
            }),
            total: { amount: (c.total_price / 100).toFixed(2), currencyCode: c.currency }
          })
        });
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (res) { return { http: r.status, res: res }; });
      }).then(function (out) {
        var status = out.res.status || (out.http === 429 ? 'limit' : 'error');
        if (status === 'sent' || status === 'already_sent') {
          d.querySelector('[data-body]').innerHTML =
            '<p class="h5 uppercase">' + esc(T.sentTitle) + '</p>' +
            '<p>' + esc(fmt(T.sent, { hours: hours, email: data.email })) + '</p>' +
            '<button type="button" class="btn btn--secondary btn--full" data-done>' + esc(T.close) + '</button>';
          d.querySelector('[data-done]').addEventListener('click', close);
          return;
        }
        if (status === 'not_applicable') { close(); pass = true; window.location.href = '/checkout'; return; }
        btn.disabled = false;
        btn.textContent = T.submit;
        show(status === 'limit' ? T.limit : status === 'invalid' ? T.missing : T.error, true);
      }).catch(function () {
        btn.disabled = false;
        btn.textContent = T.submit;
        show(T.error, true);
      });
    });

    d.showModal();
    var first = form.querySelector('input:not([value]), input[value=""]');
    if (first) first.focus();
  }

  loadSettings().then(function (s) {
    settings = s;
    if (!inScope()) return;

    // Klik „Do kasy” (formularz z przyciskiem name="checkout") – przechwycony, zanim zadziała motyw.
    document.addEventListener('submit', function (e) {
      var form = e.target;
      var b = e.submitter && e.submitter.name === 'checkout' ? e.submitter : form.querySelector && form.querySelector('button[name="checkout"]');
      if (pass || !b) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      loadCart().then(function (c) {
        if (needsQuote(c)) return openDialog();
        pass = true;
        if (form.requestSubmit) form.requestSubmit(b); else window.location.href = '/checkout';
        pass = false;
      }).catch(function () { pass = true; window.location.href = '/checkout'; });
    }, true);

    // Szuflada koszyka renderuje się od nowa po każdej zmianie – nowy przycisk dostaje napis od razu.
    new MutationObserver(function () {
      if (document.querySelector('button[name="checkout"]:not([data-wycena-seen])')) refreshSoon();
    }).observe(document.body, { childList: true, subtree: true });
    refreshSoon();
  }).catch(function () {});
})();
